export class Offres {

  public offreElevee: number;

  public offreBasse: number;

  public devise: string;

  constructor() {
    this.offreElevee = 0;
    this.offreBasse = 0;
    this.devise = '';

  }
}
